import React from 'react'
import PropTypes from 'prop-types'
import constants from 'common/helpers/constants'
import cx from 'classnames'

import OffersItem from './OffersItem/OffersItem'

import s from './Offers.scss'


const Offers = (props) => {
  const {
    items, className, itemClassName, onChoose,
    bestSize, selectedIndex, placement, offerTitle,
  } = props

  return (
    <div className={cx(s.container, className)} data-testid={constants.testIds.common.offers} role="list">
      {
        items.map(({ price, size, title, planName, save: discount }, index) => {
          const isSelected    = selectedIndex === index
          const isBest        = size === bestSize && !isSelected
          const buttonId      = placement && `${placement}${index}Button`

          const _itemClassName = cx(s.item, itemClassName, {
            [s.odd]: Boolean(items.length % 2),
          })

          const options = {
            price, size, discount, title, planName, buttonId,
            offerTitle, isBest, isSelected, onChoose,
          }

          return (
            <div className={_itemClassName} key={index} role="listitem">
              <OffersItem {...options} />
            </div>
          )
        })
      }
    </div>
  )
}

Offers.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    size: PropTypes.number.isRequired,
    price: PropTypes.string.isRequired,
    save: PropTypes.string,
    // "title" and "planName" props need for onChoose func.
    // "title" used in pages/profile/UpgradeSubscriptionPage
    // "planName" used in modals/prepaidCard/PrepaidCardWithSubscriptionPlansModal
    title: PropTypes.string,
    planName: PropTypes.string,
  })),
  bestSize: PropTypes.number,
  className: PropTypes.string,
  placement: PropTypes.string,
  offerTitle: PropTypes.string,
  itemClassName: PropTypes.string,
  selectedIndex: PropTypes.number,
  onChoose: PropTypes.func.isRequired,
}


export default Offers
